import styled from 'styled-components'
import React from 'react'
import { Modal, paddingModalStyles } from '@futures-platform/ui'

// import { InfoCircle } from '@styled-icons/boxicons-regular'

const EmbedLinkModal = ({
  EmbedLinkModalOpen,
  EmbedLinkModalClose,
  EmbedLink,
}) => {
  const handleClick = (link) => {
    window.open(link)
  }

  // const viewportWidth = window.innerWidth  + "px";
  const viewportHeight = window.innerHeight
  const viewportHeight065 = window.innerHeight * 0.9 - 12
  return (
    <Modal
      onRequestClose={EmbedLinkModalClose}
      isOpen={EmbedLinkModalOpen}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={paddingModalStyles}>
      <div
        className="confirmation-modal-content pt-4 pb-4"
        style={{ position: 'relative', height: viewportHeight }}>
        <div style={{ width: '100%', height: +viewportHeight065 }}>
          <embed
            type="text/html"
            src={EmbedLink}
            width={'100%'}
            height={viewportHeight065 - 12}
            // style ={{marginBottom: '40px'}}
          />
        </div>
        <CloseBtnWrapper>
          <button
            className="btn btn-primary btn-lg btn-primary "
            onClick={EmbedLinkModalClose}>
            GOT IT
          </button>
        </CloseBtnWrapper>
      </div>
    </Modal>
  )
}

export default EmbedLinkModal

const CloseBtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  bottom: 0;
  right: 12;
  position: sticky;
  padding-right: 20px;
`
